export const AlertsConst = {
  FlowsAlerts : 'flows-alerts',
  AlertsNotification: 'alerts-notification'
};

export const AlertNotiConst = {
  displayedColumns: [
    'createdAt',
    'message',
    'action',
  ],
};

export const AlertDetailConst = {
  displayedColumns: ['name', 'company', 'status_name', 'validated_date', 'blockchain_tx'],
};

export const AlertValidationConst = {
  displayedColumns: [
    'id',
    'actions_name',
    'created_date',
    'status_name',
    'action',
  ],
};
